/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useFetchStockOptions, useFetchStocks, useFetchExpiryDates } from '../services/stock.service';
import { OptionData, StockData, TopBestContracts, StockExpiryDateData } from '../types/stock';
import { formatDateTime, formatPrice, formatNumber, isNotNullUndefined } from '../helpers/common';
import { useNavigate } from 'react-router-dom';
import { Select, Slider, Pagination, DatePicker, Space } from 'antd';
import { DownCircleOutlined, LeftCircleOutlined, MinusOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import Images from '../assets/images';
import { storage } from '../utils/storage';
import Search from 'antd/es/input/Search';
import { IResponseModel } from '../types/response';
import { useFetchMitStocks, useFetchTopBestContracts } from '../services/mit.service';
import dayjs from 'dayjs';

const MITEvents = () => {
    const navigate = useNavigate();
    const preservedStockOptionData = useRef<OptionData[]>([]);
    const [stockOptionData, setStockOptionData] = useState<OptionData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [totalItems, setTotalItems] = useState<number>(0);
    const isAuthenticated = useRef(false);
    const isGuestUser = useRef(false);
    const [stockSymbol, setStockSymbol] = useState<string>("");
    const [expirationDate, setExpiryDate] = useState<string>("");
    const [stocks, setMitStocksList] = useState<any[]>([]);
    const [expiryDates, setExpiryDatesList] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const defaultPageSize = 20;
    const [pageSize, setPageSize] = useState<number>(defaultPageSize);
    const defaultScoreRange: [number, number] = [100, 1000];
    const [significanceScoreRange, setSignificanceScoreRange] = useState<[number, number]>(defaultScoreRange);
    const [aiScoreMarks, setAIScoreMarks] = useState<any>({});
    const [dateRange, setDateRange] = useState(["", ""]);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [expandedRowIndex, setExpandedRowIndex] = useState(null);
    const [selectedTradingType, setSelectedTradingType] = useState('spot');
    const [stockSymbolOpen, setStockSymbolOpen] = useState(false);
    const [expiryDateOpen, setExpiryDateOpen] = useState(false);
    const { RangePicker } = DatePicker;
    const topContractsData = useRef<TopBestContracts[]>([]);
    const [todayTopContractData, setTodayTopContractsData] = useState<TopBestContracts[]>([]);
    const [topRecentContractData, setRecentTopContractsData] = useState<TopBestContracts[]>([]);
    const [isLoading, setIsLoading] = useState<{ [key: number]: boolean }>({});
    const token = useRef("");
    const [showSignInPopup, setShowSignInPopup] = useState(false);
    const [scrollHeight, setScrollHeight] = useState("");
    const isSyncInProgress = useRef(false);

    const getMitStocksList = useFetchMitStocks({
        onSuccess: (response: IResponseModel<StockData>) => {
            if (response.statusCode === 200) {
                const options = response.data.map((stock: { stockSymbol: string; }) => ({
                    label: stock.stockSymbol,
                    value: stock.stockSymbol,
                }));
                setMitStocksList(options);
            }
            else {
                setMitStocksList([]);
            }
        },
    });

    const getExpiryDatesList = useFetchExpiryDates({
        onSuccess: (response: IResponseModel<StockExpiryDateData>) => {
            if (response.statusCode === 200) {
                const options = response.data.map((expiryDate: { expirationDate: string; }) => ({
                    label: formatDateTime(new Date(expiryDate.expirationDate), "DD-MMS-YYYY"),
                    value: expiryDate.expirationDate,
                }));
                setExpiryDatesList(options);
            }
            else {
                setExpiryDatesList([]);
            }
        },
    });

    const getStockOptionsDetails = useFetchStockOptions({
        onSuccess: (response: IResponseModel<OptionData>) => {
            if (response.statusCode === 200) {
                const formattedData = response.data.map((item: any, index: { toString: () => any; }) => ({
                    ...item,
                    key: index.toString(),
                }));
                preservedStockOptionData.current = formattedData;
                if (response.data.length > 0 && isNotNullUndefined(response.data[0].recordCount)) {
                    setStockOptionData(formattedData);
                    setTotalItems(response.data[0].recordCount);
                } else {
                    resetPagination();
                }
                setLoading(false);
            }
            else {
                resetPagination();
                setLoading(false);
            }
            isSyncInProgress.current = false;
        },
    });

    const resetPagination = () => {
        setStockOptionData([]);
        setCurrentPage(1);
        setPageSize(defaultPageSize);
        setTotalItems(0);
    };

    const fetchOptionsData = () => {
        setLoading(true);
        setStockOptionData([]);
        const requestParams = prepareStockOptionDetailsParams(currentPage, pageSize);
        getStockOptionsDetails.mutate(requestParams);
    };

    const fetchMitStocksList = () => {
        getMitStocksList.mutate({});
    }

    const fetchExpiryDatesList = () => {
        getExpiryDatesList.mutate({});
    }

    const prepareStockOptionDetailsParams = (page: number, pageSize: number) => ({
        stockSymbols: stockSymbol,
        significanceScoreRange: significanceScoreRange.join('-'),
        eventDateFrom: dateRange[0],
        eventDateTo: dateRange[1],
        expiryDate: expirationDate || '',
        isGuestUser: isGuestUser.current,
        pageNumber: page,
        pageSize: pageSize
    });

    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleDateChange = (_: any, dateStrings: any) => {
        resetPagination();
        setDateRange(dateStrings);
    }

    const handleSliderChange = (value: any) => {
        setSignificanceScoreRange(value);
    };

    const handleStockSymbolChange = (value: any) => {
        resetPagination();
        setStockSymbol(value?.join(','));
        if (value.length >= 1) {
            setStockSymbolOpen(false);
        }
    };

    const handleExpiryDateChange = (value: any) => {
        resetPagination();
        if (value) {
            setExpiryDate(value);
        } else {
            setExpiryDate('');
        }
        setExpiryDateOpen(false);
    };

    const onRefresh = () => {
        setLoading(true);
        fetchOptionsData();
    }

    const onSearchContractName = (event: any) => {
        const searchValue = event.target.value.trim().toLowerCase();
        if (searchValue.length >= 2) {
            const filteredData = preservedStockOptionData.current.filter(x => x.contractName.toLowerCase().includes(searchValue));
            setStockOptionData(filteredData);
        } else {
            setStockOptionData(preservedStockOptionData.current);
        }
    }

    useEffect(() => {
        const [min, max] = significanceScoreRange;
        const newMarks = {
            [min]: `${min}`,
            [max]: `${max}`,
        };
        setAIScoreMarks(newMarks);
    }, [significanceScoreRange]);

    const syncAuthAndFetchData = () => {
        if (isSyncInProgress.current) {
            return;
        }
        isSyncInProgress.current = true;

        const [isAuth, isGuest] = ["isAuthenticated", "isGuestUser"].map(key =>
            JSON.parse(storage.getLocalProperty(key) ?? "false")
        );
        isAuthenticated.current = isAuth;
        isGuestUser.current = isGuest;
        token.current = (isGuest || isAuth) ? storage.getToken() : "";
        if (token.current !== "") {
            fetchMitStocksList();
            fetchExpiryDatesList();
            isSyncInProgress.current = false;
        } else {
            setTimeout(() => {
                isSyncInProgress.current = false;
                syncAuthAndFetchData();
            }, 100);
        }
    };

    useEffect(() => {
        if (token.current !== "" && !isSyncInProgress.current) {
            isSyncInProgress.current = true;
            fetchOptionsData();
        } else {
            syncAuthAndFetchData();
        }
    }, [stockSymbol, expirationDate, dateRange, currentPage, pageSize, token.current]);

    useEffect(() => {
        window.addEventListener("authStateChanged", syncAuthAndFetchData);
        return () => {
            window.removeEventListener("authStateChanged", syncAuthAndFetchData);
        };
    }, []);

    const disableFutureAndToday = (current: any) => {
        if (isGuestUser.current) {
            return current && current >= dayjs().startOf('day');
        }
        return false;
    };

    //#region unused-code Collaps Grid Changes
    // const handleTradingTypeChange = (type: string) => {
    //     setSelectedTradingType(type);
    //     // if (type === 'spot') {
    //     //     setOptionTradeSelectedType('yahoo');
    //     // }
    // };

    // const handleOptionTradeChartChange = (type: string) => {
    //     setSelectedTradingType('option');
    //     setOptionTradeSelectedType(type);
    // };

    // const handleRowClick = (index: any) => {
    //     setExpandedRowIndex(expandedRowIndex === index ? null : index);
    //     setSelectedTradingType('spot');
    // };

    // const YahooFinance: React.FC<{ url: string }> = ({ url }) => {
    //     const iframeRef = useRef<HTMLIFrameElement | null>(null);

    //     useEffect(() => {
    //         if (iframeRef.current) {
    //             const iframe = iframeRef.current;
    //             iframe.src = url;
    //         }
    //     }, [url]);  // Depend on the `url` to change the iframe when `url` prop changes

    //     return (
    //         <div>
    //             <iframe
    //                 ref={iframeRef}
    //                 src="https://finance.yahoo.com"  // Default URL
    //                 width="100%"
    //                 height="500"
    //                 style={{ border: 'none' }}
    //                 title="Dynamic Iframe"
    //             ></iframe>
    //         </div>
    //     );
    // };

    //#endregion unused-code Collaps Grid Changes

    const handleRowClick = (index: any) => {
        const isExpanding = expandedRowIndex !== index;
        setExpandedRowIndex(isExpanding ? index : null);
        isGuestUser.current = JSON.parse(storage.getLocalProperty("isGuestUser") ?? false);
        isAuthenticated.current = JSON.parse(storage.getLocalProperty("isAuthenticated") ?? false);
        if (isGuestUser.current) {
            (expandedRowIndex !== index) ?
                setShowSignInPopup(!false)
                : setShowSignInPopup(!showSignInPopup)
        }
        setSelectedTradingType('spot');
        if (isExpanding && stockOptionData[index]?.parentStockSymbol) {
            const symbol = stockOptionData[index]?.parentStockSymbol;
            const tradeDate = stockOptionData[index]?.tradeDate;
            setIsLoading((prev) => ({ ...prev, [index]: true }));
            fetchTopBestContracts(index, symbol, tradeDate);
        }
    };

    const fetchTopBestContracts = (index: any, symbol: any, tradeDate: any) => {
        getTopBestContracts.mutate({
            stockSymbols: symbol,
            tradeDate: tradeDate,
        }, {
            onSuccess: () => {
                setIsLoading((prev) => ({ ...prev, [index]: false }));
            },
            onError: () => {
                setIsLoading((prev) => ({ ...prev, [index]: false }));
            }
        });
    };

    const getTopBestContracts = useFetchTopBestContracts({
        onSuccess: (response: IResponseModel<TopBestContracts>) => {
            if (response.statusCode === 200) {
                const formattedData = response.data.map((item: TopBestContracts, index: number) => ({
                    ...item,
                    key: index.toString(),
                }));
                const todayData = formattedData.filter((item) => item.day === 'Today');
                const recentData = formattedData.filter((item) => item.day === 'Recent');
                setTodayTopContractsData(todayData);
                setRecentTopContractsData(recentData);
                topContractsData.current = formattedData;
            } else {
                setTodayTopContractsData([]);
                setRecentTopContractsData([]);
            }
        },
    });

    const TradingViewChart = ({ symbol }: any) => {
        const containerRef = useRef<HTMLDivElement | any>('');

        useEffect(() => {
            if (containerRef.current) {
                const script = document.createElement('script');
                script.src = 'https://s3.tradingview.com/tv.js';
                script.async = true;
                script.onload = () => {
                    new window.TradingView.widget({
                        symbol: symbol || 'SAVA',
                        interval: 'D',
                        width: '100%',
                        height: '500',
                        container_id: containerRef.current?.id || '',
                        allow_symbol_change: true,
                        hide_top_toolbar: true,
                        hide_legend: true,
                    });
                };
                document.head.appendChild(script);
            }
        }, [symbol]);

        return (
            <div ref={containerRef} id={`tradingview-chart-${symbol}`} />
        );
    };

    useEffect(() => {
        if (!isGuestUser.current) {
            setScrollHeight(isFilterOpen ?
                "h-[calc(100vh-395px)] xl:h-[calc(100vh-245px)]" :
                `h-[calc(100vh-130px)] ${!isAuthenticated.current ? "xl:h-[calc(100vh-215px)]" : "xl:h-[calc(100vh-145px)]"}`
            );
        } else {
            setScrollHeight(isFilterOpen ?
                "h-[calc(100vh-540px)] md:h-[calc(100vh-315px)] xl:h-[calc(100vh-305px)]" :
                `h-[calc(100vh-270px)] ${!isAuthenticated.current ? "xl:h-[calc(100vh-215px)]" : "xl:h-[calc(100vh-145px)]"}`
            );
        }
    }, [isGuestUser.current, isFilterOpen, isAuthenticated.current]);

    const RowSignInPopup = ({ index, onClose }: any) => {
        return (
            <div className="inline-block bg-white p-6 rounded-lg shadow-lg text-center">
                <p className="text-lg font-semibold mb-4">
                    Please Sign In to unlock real-time data.
                </p>
                <button
                    onClick={() => onClose(index)}
                    className="mt-2 py-2 px-4 text-xs lg:text-base text-white border border-blue-midnight bg-blue-midnight rounded hover:bg-transparent hover:text-blue-midnight transition"
                >
                    Okay
                </button>
            </div>
        );
    };



    return (
        <div className='mb-2.5'>
            <div className='p-2.5 lg:p-4 bg-white rounded-xl shadow-box'>
                {/* <div>
                    <h2 className='text-[17px] hidden 2xl:block lg:text-[21px] font-bold text-black text-start mb-2'>AI Trade Recommendation</h2>
                </div> */}
                <div className="mb-2">
                    <div className='flex items-center gap-2 ml-7 sm:ml-0'>
                        {/* Filter Button - Visible only on mobile */}
                        <button
                            onClick={() => setIsFilterOpen(!isFilterOpen)} // Toggle the filter section
                            className="py-[5px] px-2 lg:py-2 lg:px-4 text-black border text-sm sm:text-base border-blue-midnight rounded-md flex items-center justify-between gap-1.5 w-full"
                        >
                            Filter
                            {/* Conditional Icon Rendering */}
                            {isFilterOpen ? (
                                <DownCircleOutlined className="text-blue-midnight" />
                            ) : (
                                <LeftCircleOutlined className="text-blue-midnight" />
                            )}
                        </button>
                        <div>
                            <button
                                onClick={() => {
                                    onRefresh();
                                }}
                                className="py-2 px-2 lg:px-4 text-xs lg:text-base lg:py-2 text-white border border-blue-midnight bg-blue-midnight rounded hover:bg-transparent hover:text-blue-midnight flex items-center gap-1.5"
                            >
                                <ReloadOutlined />
                                {loading ? "Loading..." : "Refresh"}
                            </button>
                        </div>
                    </div>
                    {isFilterOpen && (
                        <div className='block md:items-center md:flex gap-4 w-full justify-end rounded-lg shadow-md mt-2 p-2 sm:p-3.5'>
                            <div className='lg:flex gap-4 items-center w-full justify-end'>
                                <div>
                                    <Search placeholder="Search Contract Name" allowClear onChange={onSearchContractName} className='w-full text-start mit-searchbar' />
                                </div>
                                <div>
                                    <Select
                                        allowClear
                                        className='w-full min-w-60 md:max-w-[600px] text-start multi-user-dropdown h-10 mt-2 lg:mt-0'
                                        placeholder="Select Expiry Date"
                                        onChange={handleExpiryDateChange}
                                        options={expiryDates}
                                        open={expiryDateOpen}
                                        onDropdownVisibleChange={(visible) => setExpiryDateOpen(visible)}
                                    />
                                </div>
                                <div>
                                    <Space direction="vertical" size={12} className='w-full my-2 lg:my-0'>
                                        <RangePicker
                                            onChange={handleDateChange}
                                            className='p-2 w-full datepicker-table'
                                            disabledDate={disableFutureAndToday}
                                        />
                                    </Space>
                                </div>
                                <div>
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        className='w-full min-w-80 md:max-w-[600px] text-start multi-user-dropdown'
                                        placeholder="Select Stock Symbol" //"Select Companies"
                                        onChange={handleStockSymbolChange}
                                        options={stocks}
                                        open={stockSymbolOpen} // Control dropdown visibility
                                        onDropdownVisibleChange={(visible) => setStockSymbolOpen(visible)} // Update open state on dropdown visibility change
                                    />
                                </div>
                            </div>
                            <div className='flex justify-between items-center gap-8 mt-2 md:mt-0'>
                                <div className='max-md:w-[95%]'>
                                    <p className='absolute text-sm font-semibold '>Open AI Score</p>
                                    <Slider range
                                        value={significanceScoreRange}
                                        marks={aiScoreMarks}
                                        min={1} max={1000}
                                        onChange={(evt) => { handleSliderChange(evt) }}
                                        className='w-full md:w-60 top-4 range-slider h-5' />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="overflow-auto">
                    {loading ? (
                        <div className="space-y-4">
                            {Array.from({ length: 10 }).map((_, i) => (
                                <div key={i} className="animate-pulse flex w-full">
                                    <div className="w-1/12 h-6 bg-gray-300 rounded hidden lg:block"></div>
                                    <div className="w-2/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-1/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-1/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-1/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-1/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-1/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-1/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-1/12 h-6 bg-gray-300 rounded mx-1"></div>
                                    <div className="w-2/12 h-6 bg-gray-300 rounded mx-1"></div>
                                </div>
                            ))}
                        </div>
                    ) : stockOptionData.length === 0 ? (
                        <div>
                            <p>No records found</p>
                        </div>
                    ) : (
                        <div className={`overflow-x-auto mt-1.5 ${scrollHeight}`}>
                            <table className="min-w-full w-full  border border-[#eeeeee]">
                                <thead className='sticky top-0 z-10 shadow-md border border-gray'>
                                    <div className='h-full absolute bg-[#EEEEEE] -z-10 w-full top-[-1px] -mt-[1px]'></div>
                                    <tr className=' bg-white text-black text-xs lg:text-sm'>
                                        {/* <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border border-t-0 border-gray whitespace-nowrap' rowSpan={2}></th> */}
                                        {/* <th className="hidden lg:table-cell py-1 md:py-2 px-3.5 text-left border border-t-0 border-gray whitespace-nowrap" rowSpan={2}>Sr No.</th> */}
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 min-w-[185px] md:w-[200px] lg:min-w-[230px] text-center border border-t-0 border-gray whitespace-nowrap" rowSpan={2}>Symbol</th>
                                        {/* <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap" rowSpan={2}>At</th> */}
                                        <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' rowSpan={2}>AI Score</th>
                                        {/* <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' rowSpan={2}>Trade Side</th> */}
                                        <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' colSpan={6}>
                                            <div className='flex justify-around'>
                                                <div>
                                                    <span>Price</span>
                                                </div>
                                            </div>
                                        </th>
                                        <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' colSpan={5}>
                                            Option Greeks
                                        </th>

                                        {/* <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' colSpan={2}>Spot</th> */}
                                        {/* <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' rowSpan={2}>Price</th>
                                        <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' rowSpan={2}>Ticker</th> */}
                                        <th className='py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap' rowSpan={2}> Moneyness</th>
                                    </tr>
                                    <tr className='bg-white text-black text-xs lg:text-sm'>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 whitespace-nowrap grid">
                                            <span className='bg-[#03314B4D] border border-grey-slate rounded-[4px] text-[8px] text-grey-slate font-medium leading-[11px] sm:leading-[13px]'>OPTION</span>
                                            <span className='bg-[#6C727F4D] border border-grey-raven rounded-[4px] text-[8px] text-grey-raven font-medium mt-1 sm:leading-[13px] leading-[11px]'>SPOT</span>
                                        </th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">Entry</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">Target</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">Stop loss</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">Volume</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">Premium</th>

                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">Delta</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">IV</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">OI</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">OI Change</th>
                                        <th className="py-1 md:py-2 px-2.5 lg:px-3.5 text-center border-t-0 border border-gray whitespace-nowrap">Highest OI</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stockOptionData.map((item: any, index: any) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <tr
                                                    className={`border-b border-gray ${item.significanceScore > 500
                                                        ? 'bg-green-dark-green-500 text-white'
                                                        : item.significanceScore > 400
                                                            ? 'bg-green-medium-cyan-400 text-white'
                                                            : item.significanceScore > 300
                                                                ? 'bg-green-light-green-300'
                                                                : item.significanceScore > 200
                                                                    ? 'bg-green-light-green-200'
                                                                    : ''
                                                        }`}
                                                    onClick={() => handleRowClick(index)} // Toggle row expansion
                                                    style={{ cursor: 'pointer' }} // Make it visually clear that it's clickable
                                                >
                                                    {/* <td>
                                                        <button
                                                            onClick={() => handleRowClick(index)}
                                                            className="text-sm font-bold flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5 rounded-md transition-all duration-300 collapse-icon"
                                                        >
                                                            {expandedRowIndex === index ? <MinusOutlined /> : <PlusOutlined />}
                                                        </button>
                                                    </td> */}
                                                    {/* <td className='p-2.5 text-xs lg:text-base lg:p-3.5 text-left hidden lg:block'>{item.rowNumber}</td> */}
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-start'>
                                                        <div className='flex items-baseline gap-4'>
                                                            <div>
                                                                <button
                                                                    onClick={() => handleRowClick(index)}
                                                                    className="text-xs font-bold flex items-center justify-center w-3 h-3 sm:w-5 sm:h-3 rounded-md transition-all duration-300 collapse-icon"
                                                                >
                                                                    {expandedRowIndex === index ? <MinusOutlined /> : <PlusOutlined />}
                                                                </button>
                                                            </div>
                                                            {/* <div className={`${item.significanceScore > 400 ? 'text-white' : 'text-black-500'}`}>
                                                                {item.contractName}
                                                            </div> */}
                                                            <div>
                                                                {/* <p className='font-bold text-grey-slate'>{item.shortContractName}</p> */}
                                                                <p className={`font-bold text-grey-slate ${item.significanceScore > 500 ? 'text-white' : ''}`}>
                                                                    <a
                                                                        href={`https://finance.yahoo.com/quote/${item.yahooFinanceStockSymbol}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="hover:underline"
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {item.shortContractName}
                                                                    </a>
                                                                </p>
                                                                <div className='flex gap-4 text-grey-suva font-medium text-xs'>
                                                                    <p className={`${item.significanceScore > 400 ? 'text-white' : ''}`}>{formatDateTime(new Date(item.expirationDate), "DD-MMS-YYYY")}</p>
                                                                    <div className="whitespace-nowrap relative group text-center">
                                                                        <p className={`${item.significanceScore > 400 ? 'text-white' : ''}`}>{item.createdAtAgo}</p>
                                                                        <div className="absolute bottom-full left-1/2 transform -translate-x-3/4 lg:transform-translate-x-2/3 mb-2 hidden group-hover:block bg-blue-midnight text-white text-xs rounded px-2 py-1 z-10">
                                                                            {new Date(item.createdAt).toLocaleString('en-GB', {
                                                                                weekday: 'short',
                                                                                year: 'numeric',
                                                                                month: 'short',
                                                                                day: '2-digit',
                                                                                hour: '2-digit',
                                                                                minute: '2-digit',
                                                                                second: '2-digit',
                                                                                hour12: true,
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <div>
                                                                <div className='flex items-center gap-1'>
                                                                    <a href={`https://finance.yahoo.com/quote/${item.yahooFinanceStockSymbol}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer">
                                                                        <img src={Images.yahooicon} className='w-[15px] md:w-5' alt="Yahoo" />
                                                                    </a>
                                                                    <a href={`https://tradingview.com/chart?symbol=${item.tradingViewStockSymbol}&interval=1D`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer">
                                                                        <img src={Images.tradingicon} className='w-[15px] md:w-5' alt="Trading" />
                                                                    </a>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                    </td>
                                                    {/* <td className="p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap relative group text-center">
                                                        <span>{item.createdAtAgo}</span>
                                                        <div className="absolute bottom-full left-1/2 transform -translate-x-3/4 lg:transform-translate-x-2/3 mb-2 hidden group-hover:block bg-blue-midnight text-white text-xs rounded px-2 py-1 z-10">
                                                            {new Date(item.createdAt).toLocaleString('en-GB', {
                                                                weekday: 'short',
                                                                year: 'numeric',
                                                                month: 'short',
                                                                day: '2-digit',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                second: '2-digit',
                                                                hour12: true,
                                                            })}
                                                        </div>
                                                    </td> */}
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        {/* <span
                                                            className={`px-2 py-1 rounded ${item.significanceScore > 500
                                                                ? 'bg-green-deep-fir text-white border border-white'
                                                                : item.significanceScore > 300
                                                                    ? 'bg-green-dark-pastel text-white border border-black'
                                                                    : item.significanceScore > 200
                                                                        ? 'bg-green-screamin text-black border border-black'
                                                                        : item.significanceScore < 100
                                                                            ? 'bg-white text-black'
                                                                            : 'bg-green-granny text-black'
                                                                }`} 
                                                        >
                                                            {Math.round(item.significanceScore)}
                                                        </span> */}
                                                        <div className='gap-4 flex justify-center'>
                                                            {item.openAiEnabled && (
                                                                <div className="relative inline-flex items-center">
                                                                    <div className="bg-[#00B0871A] px-3.5 rounded-sm border border-[#00B087]">
                                                                        <span className={`font-semibold text-xs font-poppins ${Math.round(item.significanceScore) > 500 ? 'text-white' : 'text-[#03314B]'
                                                                            }`}
                                                                        >
                                                                            {Math.round(item.openAiScore)}
                                                                        </span>
                                                                    </div>
                                                                    <div className="absolute top-0 rounded-sm right-0 -translate-y-1/2 translate-x-1/2 bg-[#00B087] text-white font-medium flex items-center justify-center w-3.5 h-3.5">
                                                                        <img src={Images.chatgpt} className='w-3 h-3' alt="Chat GPT" />
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {item.xAiEnabled && (
                                                                <div className="relative inline-flex items-center">
                                                                    <div className="bg-[#00B08733] px-3.5 rounded-sm border border-[#00B087]">
                                                                        <span className={`font-semibold text-xs font-poppins ${Math.round(item.significanceScore) > 500 ? 'text-white' : 'text-[#03314B]'
                                                                            }`}
                                                                        >
                                                                            {Math.round(item.xAiScore)}
                                                                        </span>
                                                                    </div>
                                                                    <div className="absolute top-0 rounded-sm right-0 -translate-y-1/2 translate-x-1/2 bg-[#00B087] text-white font-medium flex items-center justify-center w-[14px] h-[14px] text-[9px]">
                                                                        <img src={Images.xai} className='w-3 h-3' alt="xAi Grok" />
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div className="relative inline-flex items-center">
                                                                <div className="bg-[#00B0874D] px-3.5 rounded-sm border border-[#00B087]">
                                                                    <span className={`font-semibold text-xs font-poppins ${Math.round(item.significanceScore) > 500 ? 'text-white' : 'text-[#03314B]'
                                                                        }`}
                                                                    >
                                                                        {Math.round(item.significanceScore)}
                                                                    </span>
                                                                </div>
                                                                <div className="absolute top-0 rounded-sm right-0 -translate-y-1/2 translate-x-1/2 bg-[#00B087] text-white font-medium flex items-center justify-center w-[14px] h-[14px] text-[9px]">
                                                                    <img src={Images.aiwhite} className='w-2.5' alt="xAi Grok" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {/* <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`px-1.5 lg:px-2 py-0.5 lg:py-1 rounded ${item.contractType === 'Call' ? 'bg-green-mountain-meadow bg-opacity-60 border-green-mountain-meadow border  text-black' : 'bg-red-persian bg-opacity-60 text-white border-red-persian border'}`}>
                                                            Buy {item.contractType}
                                                        </span>
                                                    </td> */}


                                                    {/* Price */}
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'></td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>${formatPrice(item.optionPrice.toFixed(2))}</span>
                                                        <span className={`text-grey-raven font-medium ${item.significanceScore > 400 ? 'text-white' : ''}`}
                                                        >${formatPrice(item.spotPrice.toFixed(2))} </span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>${formatPrice(item.optionTargetPrice.toFixed(2))}</span>
                                                        <span className={`text-grey-raven font-medium ${item.significanceScore > 400 ? 'text-white' : ''}`}
                                                        >${formatPrice(item.spotTargetPrice.toFixed(2))} </span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>${formatPrice(item.optionStopLossPrice.toFixed(2))} </span>
                                                        <span className={`text-grey-raven font-medium ${item.significanceScore > 400 ? 'text-white' : ''}`}
                                                        >${formatPrice(item.spotStopLossPrice.toFixed(2))} </span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>{formatPrice(item.contractVolume)}</span>
                                                        <span className={`text-grey-raven font-medium ${item.significanceScore > 400 ? 'text-white' : ''}`}
                                                        >{formatPrice(item.spotVolume)}</span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>${formatPrice(item.optionPremium)}</span>
                                                        <span className={`text-grey-raven font-medium ${item.significanceScore > 400 ? 'text-white' : ''}`}
                                                        >${formatPrice(item.spotPremium)}</span>
                                                    </td>
                                                    {/* Option Greeks  */}
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>{item.optionDelta.toFixed(2)}</span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>{(item.impliedVolatility !== 0) ? item.impliedVolatility : '-'}</span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span className={`block text-grey-slate font-medium ${item.significanceScore > 500 ? 'text-white' : ''}`}>{(item.openInterest !== 0) ? formatNumber(item.openInterest) : '-'}</span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span
                                                            className={`block font-medium ${item.openInterestChange === 0
                                                                ? 'text-grey-slate'
                                                                : item.openInterestChange < 0
                                                                    ? 'text-red-500'
                                                                    : 'text-green-persian'
                                                                }`}>
                                                            {(item.openInterestChange !== 0) ? formatNumber(item.openInterestChange) : '-'}
                                                        </span>
                                                    </td>
                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <span
                                                            className={`block font-medium ${item.highestOpenInterestContractName
                                                                ? item.contractType === item.highestOpenInterestContractType
                                                                    ? 'text-green-persian'
                                                                    : 'text-red-500'
                                                                : 'text-grey-slate'
                                                                }`}
                                                        >
                                                            {item.highestOpenInterestContractName ? item.highestOpenInterestContractName : '-'}
                                                        </span>
                                                        <span
                                                            className={`font-medium ${item.highestOpenInterest
                                                                ? item.contractType === item.highestOpenInterestContractType
                                                                    ? 'text-green-persian'
                                                                    : 'text-red-500'
                                                                : 'text-grey-slate'
                                                                }`}
                                                        >
                                                            {item.highestOpenInterest ? formatNumber(item.highestOpenInterest) : '-'}
                                                        </span>
                                                    </td>

                                                    <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center '>
                                                        <span
                                                            className={`px-2 rounded-[4px] ${(item.moneyness === 'ATM')
                                                                ? 'bg-[#ED841B61] border border-orange-carrot text-orange-carrot'
                                                                : (item.moneyness === 'OTM')
                                                                    ? 'bg-[#e24c4a61] border border-red-persian text-red-persian'
                                                                    : (item.moneyness === 'ITM')
                                                                        ? 'bg-[#16C09861] border border-green-persian text-green-persian'
                                                                        : ''
                                                                }`}
                                                        >
                                                            {item.moneyness}
                                                        </span>
                                                    </td>

                                                    {/* <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>${formatPrice(item.lastPrice)}</td> */}
                                                    {/* <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                    <span
                                                        className={`${item.significanceScore > 400
                                                            ? 'text-white'
                                                            : item.unrealizedPnL == null
                                                                ? 'text-black'
                                                                : item.unrealizedPnL < 0
                                                                    ? 'text-red-700'
                                                                    : 'text-green-700'
                                                            }`}
                                                    >
                                                        ${item.unrealizedPnL == null ? '0.00' : formatNumberWithCommas(item.unrealizedPnL)}
                                                    </span>
                                                </td> */}
                                                    {/* <td className='p-2.5 text-xs lg:text-sm lg:p-3.5 whitespace-nowrap text-center'>
                                                        <a
                                                            href={`https://tradingview.com/chart?symbol=${item.parentStockSymbol}&interval=1D`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-500 hover:underline"
                                                        >
                                                            {item.parentStockSymbol} (${formatNumberWithCommas(item.spotLastPrice)})
                                                        </a>
                                                    </td> */}
                                                </tr>
                                                {isLoading[index] ? (
                                                    <tr>
                                                        <td colSpan={14} className="p-4 text-left">
                                                            <div className="space-y-4">
                                                                {Array.from({ length: 5 }).map((_, i) => (
                                                                    <div key={i} className="animate-pulse flex w-full">
                                                                        <div className="w-full h-5 bg-gray-300 rounded hidden lg:block"></div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    expandedRowIndex === index && (
                                                        <tr className="bg-gray-100 relative">
                                                            <td colSpan={7} className={`p-4 text-left ${isGuestUser.current ? 'blur-md pointer-events-none' : ''}`}>
                                                                <div className="">
                                                                    {/* Left side: Radio buttons for Spot and Option */}
                                                                    <div className="flex items-center gap-4">
                                                                        {/* <div className="flex items-center cursor-pointer">
                                                                        <input
                                                                            type="radio"
                                                                            id={`spot-${index}`}
                                                                            name={`contractType-${index}`}
                                                                            value="spot"
                                                                            className="mr-2 cursor-pointer"
                                                                            checked={selectedTradingType === 'spot'}
                                                                            onChange={() => handleTradingTypeChange('spot')}
                                                                        />
                                                                        <label htmlFor={`spot-${index}`} className={`text-sm ${selectedTradingType === 'spot' ? 'text-blue-midnight font-bold' : 'text-gray-700'
                                                                            }`}>Spot</label>
                                                                    </div>
                                                                    <div className="flex items-center cursor-pointer">
                                                                        <input
                                                                            type="radio"
                                                                            id={`option-${index}`}
                                                                            name={`contractType-${index}`}
                                                                            value="option"
                                                                            className="mr-2 cursor-pointer"
                                                                            checked={selectedTradingType === 'option'}
                                                                            onChange={() => handleTradingTypeChange('option')}
                                                                        />
                                                                        <label htmlFor={`option-${index}`} className={`text-sm ${selectedTradingType === 'option' ? 'text-blue-midnight font-bold' : 'text-gray-700'
                                                                            }`}>Option</label>
                                                                    </div> */}

                                                                        {/* Additional buttons under 'Option' */}
                                                                        {/* {selectedTradingType === 'option' && (
                                                                        <div className="flex flex-col space-y-2 ml-2">
                                                                            <div className="flex items-center">
                                                                                <input
                                                                                    type="radio"
                                                                                    id={`tradeview-${index}`}
                                                                                    name={`optionType-${index}`}
                                                                                    value="tradeview"
                                                                                    checked={optionTradeSelectedType === 'tradeview'}
                                                                                    onChange={() => handleOptionTradeChartChange('tradeview')}
                                                                                />
                                                                                <label htmlFor={`tradeview-${index}`} className="text-sm">TradingView</label>
                                                                            </div>
                                                                            <div className="flex items-center">
                                                                                <input
                                                                                    type="radio"
                                                                                    id={`yahoo-${index}`}
                                                                                    name={`optionType-${index}`}
                                                                                    value="yahoo"
                                                                                    checked={optionTradeSelectedType === 'yahoo'}
                                                                                    onChange={() => handleOptionTradeChartChange('yahoo')}
                                                                                />
                                                                                <label htmlFor={`yahoo-${index}`} className="text-sm">Yahoo Finance</label>
                                                                            </div>
                                                                        </div>
                                                                    )} */}
                                                                    </div>

                                                                    {/* Right side: TradingView Chart */}
                                                                    <div className="flex-1 ml-4">
                                                                        <div className="mt-4">
                                                                            {/* Render the TradingView chart or Yahoo Finance iframe based on selected options */}

                                                                            <TradingViewChart symbol={selectedTradingType === 'spot' ? stockOptionData[index]?.parentStockSymbol :
                                                                                selectedTradingType === 'option' ? stockOptionData[index]?.tradingViewStockSymbol : "SAVA"
                                                                            } />

                                                                            {/* {selectedTradingType === 'spot' && (
                                                                            <TradingViewChart symbol={data[index]?.parentStockSymbol} />
                                                                        )} */}
                                                                            {/* 
                                                                        {selectedTradingType === 'option' && optionTradeSelectedType === 'tradeview' && (
                                                                            <TradingViewChart symbol={data[index]?.tradingViewStockSymbol} />
                                                                        )} */}

                                                                            {/* {selectedTradingType === 'option' && optionTradeSelectedType === 'yahoo' && (
                                                                            <YahooFinance url={`https://finance.yahoo.com/chart/${item.yahooFinanceStockSymbol}`} />
                                                                        )} */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td colSpan={7} className={`${isGuestUser.current ? 'blur-md pointer-events-none' : ''}`}>
                                                                {/* Today Best Contracts */}
                                                                <div className="p-2.5">
                                                                    <div className="bg-white rounded-md shadow-md p-3 pl-2.5 w-full mt-2">
                                                                        <div className="flex justify-between items-center pb-2 border-b border-[#eeeeee]">
                                                                            <div className="flex items-center gap-2">
                                                                                <h2 className="text-sm font-semibold text-grey-slate">Today's Top Options by Volume</h2>
                                                                            </div>
                                                                        </div>
                                                                        <div className="overflow-x-auto rounded-lg my-3">
                                                                            {todayTopContractData.length > 0 ? (
                                                                                <table className="w-full text-sm border-collapse">
                                                                                    <thead className="sticky top-0 border-b border-[#eeeeee]">
                                                                                        <tr className="text-black text-center">
                                                                                            <th className="font-extralight text-xs pt-0 p-1.5 border-r text-left">Symbol</th>
                                                                                            <th className="font-extralight text-xs pt-0 p-1.5">Volume</th>
                                                                                            <th className="font-extralight text-xs pt-0 p-1.5">Premium</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {todayTopContractData.map((contract, i) => (
                                                                                            <tr key={i} className="text-xs font-medium text-center">
                                                                                                <td className="font-medium px-1.5 pt-2.5 border-r text-left">
                                                                                                    <span className="text-grey-raven block">{contract.contractName}</span>
                                                                                                </td>
                                                                                                <td className="font-medium px-1.5 pt-2.5 border-r">
                                                                                                    <span className="text-grey-raven block">{(contract.totalVolume !== 0) ? formatPrice(contract.totalVolume) : '-'}</span>
                                                                                                </td>
                                                                                                <td className="text-gray-800 px-1.5 pt-2.5">
                                                                                                    <span className="text-grey-raven block">${(contract.totalPremium !== 0) ? formatPrice(contract.totalPremium) : '-'}</span>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            ) : (
                                                                                <p className="text-center text-gray-500">No data found</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* Recent Best Contracts */}
                                                                <div className="p-2.5">
                                                                    <div className="bg-white rounded-md shadow-md p-3 pl-2.5 w-full mt-2">
                                                                        <div className="flex justify-between items-center pb-2 border-b border-[#eeeeee]">
                                                                            <div className="flex items-center gap-2">
                                                                                <h2 className="text-sm font-semibold text-grey-slate">Top Options by Volume (Last 5 Days)</h2>
                                                                            </div>
                                                                        </div>
                                                                        <div className="overflow-x-auto rounded-lg my-3">
                                                                            {topRecentContractData.length > 0 ? (
                                                                                <table className="w-full text-sm border-collapse">
                                                                                    <thead className="sticky top-0 border-b border-[#eeeeee]">
                                                                                        <tr className="text-black text-center">
                                                                                            <th className="font-extralight text-xs pt-0 p-1.5 border-r text-left">Symbol</th>
                                                                                            <th className="font-extralight text-xs pt-0 p-1.5">Volume</th>
                                                                                            <th className="font-extralight text-xs pt-0 p-1.5">Premium</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {topRecentContractData.map((contract, i) => (
                                                                                            <tr key={i} className="text-xs font-medium text-center">
                                                                                                <td className="font-medium px-1.5 pt-2.5 border-r text-left">
                                                                                                    <span className="text-grey-raven block">{contract.contractName}</span>
                                                                                                </td>
                                                                                                <td className="font-medium px-1.5 pt-2.5 border-r">
                                                                                                    <span className="text-grey-raven block">{(contract.totalVolume !== 0) ? formatPrice(contract.totalVolume) : '-'}</span>
                                                                                                </td>
                                                                                                <td className="text-gray-800 px-1.5 pt-2.5">
                                                                                                    <span className="text-grey-raven block">${(contract.totalPremium !== 0) ? formatPrice(contract.totalPremium) : '-'}</span>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            ) : (
                                                                                <p className="text-center text-gray-500">No data found</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            {showSignInPopup && (
                                                                <div className="absolute inset-0 flex items-center justify-center">
                                                                    <RowSignInPopup index={index} onClose={handleRowClick} />
                                                                </div>
                                                            )}
                                                        </tr>
                                                    )
                                                )}
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            <Pagination
                total={totalItems}
                current={currentPage}
                pageSize={pageSize}
                onChange={handlePageChange}
                className='mt-2.5 md:px-6 pagination-table'
                showSizeChanger
                align='end'
                showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            />
        </div>
    );
};

export default MITEvents;


